import { render, staticRenderFns } from "./ClienteStatus.vue?vue&type=template&id=4b5c1953"
import script from "./ClienteStatus.vue?vue&type=script&lang=js"
export * from "./ClienteStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports